import PropTypes from 'prop-types';

export var validChartTypes = PropTypes.oneOf(['chart', 'stockChart']);

export var validAxisTypes = PropTypes.oneOf(['category', 'linear', 'logarithmic', 'datetime']);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jsx-highcharts/dist/es/utils/propTypeValidators.js
// module id = 300
// module chunks = 0